import {AccountService} from '../../../../components/accounts';
import {
    correctAsecurityLegsAccountDict,
    OrderAspreaderAlgoParams,
    parseAsecurityConfig,
    parseOrderAspreaderAlgoParamsAccounts
} from '../../../../components/security/aspreader-security';
import {OrderAlgoType, parseAlgoTypeFromOrder} from '../../../../enums/order-algo-type';
import {NewOrder} from '../../../../models/order';
import {Security} from '../../../../models/security';

export enum AspreaderAlgoParamsError {
    ACCOUNTS_ARE_INVALID = 'ACCOUNTS_ARE_INVALID'
}

export const getAspreaderAlgoParamsErrors = (
    newOrder: NewOrder,
    security: Security,
    accountService: AccountService
): AspreaderAlgoParamsError[]  => {
    const errors: AspreaderAlgoParamsError[] = [];
    const algoType = parseAlgoTypeFromOrder(newOrder.algoType);

    if (algoType === OrderAlgoType.AUTOSPREADER) {
        const algoParams = (newOrder.algoParams || {}) as OrderAspreaderAlgoParams;

        const accountsDict = algoParams.accountSecurities
            && parseOrderAspreaderAlgoParamsAccounts(algoParams.accountSecurities, accountService);

        const asecurityConfig = parseAsecurityConfig(security);

        const isAccountsValid = accountsDict && asecurityConfig
            && (
                correctAsecurityLegsAccountDict(security, asecurityConfig.legs, accountsDict, accountService)
                === accountsDict
            );

        if (!isAccountsValid) {
            errors.push(AspreaderAlgoParamsError.ACCOUNTS_ARE_INVALID);
        }
    }

    return errors;
};
